import { useState } from 'react';
import { Lock, Zap } from 'lucide-react';
import { Button } from '@/components/ui/button';
import TrialSkipDialog from '@/components/TrialSkipDialog';
import { ACADEMY_MODULES } from '@/data/academyModules';

interface LockedModuleOverlayProps {
  moduleTitle: string;
}

const LockedModuleOverlay = ({ moduleTitle }: LockedModuleOverlayProps) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
      <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mb-4">
        <Lock className="w-7 h-7 text-muted-foreground" />
      </div>
      <h3 className="text-lg font-bold text-foreground mb-1">{moduleTitle}</h3>
      <p className="text-sm text-muted-foreground max-w-xs mb-6 leading-relaxed">
        Ten moduł jest dostępny po aktywacji konta. Odblokuj pełny dostęp do wszystkich {ACADEMY_MODULES.length} modułów szkolenia.
      </p>
      <Button
        onClick={() => setDialogOpen(true)}
        className="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white shadow-sm"
      >
        <Zap className="w-4 h-4 mr-2" />
        Aktywuj teraz
      </Button>
      <TrialSkipDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
};

export default LockedModuleOverlay;
